import * as angular from 'angular';

export class Controller {

    /** @ngInject */
    constructor($state, Alert, ApplicationsResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
    }

    $onInit() {
        this.config = {...this.application};
    }

    cancel() {
        this.config = {...this.application};
    }

    is(...types) {
        return types.includes(this.application.applicationType.slug);
    }

    notModified() {
        return angular.equals(this.application, this.config);
    }

    save() {
        this.isSaving = true;
        this.ApplicationsResource
            .updateApplicationConfiguration(this.companyId, this.application.id, this.config)
            .then(() => {
                this.Alert('success', 'company.manage-application.users.saved');
                Object.assign(this.application, this.config);
                this.$state.reload('company.manage-application');
            })
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return form.$invalid || this.isSaving || this.notModified();
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/customize-user-authentication/customize-user-authentication.controller.js